const MAX_COMPARE_FEATURES = 6;
export function buildCompareSeatCards(seats, priorityFeatures) {
  const featuresByApiName = new Map((priorityFeatures !== null && priorityFeatures !== void 0 ? priorityFeatures : []).map(product => [product.productApiName, product.priorityFeatures.slice(0, MAX_COMPARE_FEATURES).map(feature => feature.displayName)]));
  return seats.map(seat => {
    var _featuresByApiName$ge;
    return Object.assign({}, seat, {
      features: (_featuresByApiName$ge = featuresByApiName.get(seat.apiName)) !== null && _featuresByApiName$ge !== void 0 ? _featuresByApiName$ge : []
    });
  });
}